export default __webpack_public_path__ + "static/media/codecrush2.399a5150.jpg";